import { Position } from "./Dropdown.types";

export function setPosition(position: Position | [Position, Position]): string {
  if (!Array.isArray(position)) {
    switch (position) {
      case "left":
        return `
              left: 0;
              right: auto;
          `;
      default:
        return "";
    }
  }

  return "";
}
